import { Controller } from "@hotwired/stimulus"

// One per filter chip-group dropdown. Manages open/close, "all/none"
// shortcuts, and submitting the parent form on any change.
export default class extends Controller {
  static targets = [ "menu", "input" ]

  toggle(event) {
    event.preventDefault()
    this.menuTarget.classList.toggle("hidden")
  }

  closeIfOutside(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
    }
  }

  selectAll() {
    this.inputTargets.forEach(i => { i.checked = true })
    this.submit()
  }

  selectNone() {
    this.inputTargets.forEach(i => { i.checked = false })
    this.submit()
  }

  submit() {
    const form = this.element.closest("form")
    if (form) form.requestSubmit()
  }
}
